var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex p-2 job-item"},[_c('div',{staticClass:"job-item__icon-container"},[_c('v-img',{staticClass:"job-item__icon-container__icon",attrs:{"src":require("@/assets/svg/booking-icon.svg"),"size":"50","label":"Booking Icon"}})],1),_c('div',{staticClass:"job-item__label"},[_vm._v(_vm._s(_vm.role))])])
}
var staticRenderFns = []

export { render, staticRenderFns }